export const NO_VALUE_STRING = '-'
